import { render, staticRenderFns } from "./BigNotify.vue?vue&type=template&id=3a06aa96&"
import script from "./BigNotify.vue?vue&type=script&lang=js&"
export * from "./BigNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports